let allResults = [];
let currentPage = 1;
let reviewsPerPage = 10;
let viewMoreReviews = '#view-more-reviews';
let seeAllReviews = '#see-all-reviews';
let reviewsShopifySection = '.embark-location-reviews';
let reviewsCTA = '.location-reviews-cta';

// Fetch reviews for the specified page and number of reviews to show
function fetchPage(page, reviewsToShow, append = false, initialLoad = false) {
	const url = `https://app.listen360.com/organizations/${orgID}/reviews/public.js?callback=&origin=widget&page=${page}&per_page=${reviewsToShow}&random=false`;

	$.ajax({
		url: url,
		method: 'GET',
		dataType: 'jsonp',
		success: function (data) {
			if (data.length > 0) {

				// Filter out reviews with single word comments
				const filteredData = data.filter(review => review.comments.trim().split(/\s+/).length > 1);

				allResults = allResults.concat(filteredData);
				// console.log(`Fetched page ${page}, items: ${data.length}`);

				if (filteredData.length < 6) {
					$(seeAllReviews).remove();
					$(viewMoreReviews).remove();
				}

				if (initialLoad) {
					renderInitialReviews();
				} else if (append) {
					// Append reviews to the modal
					renderReviews(filteredData, '#reviews-modal');
				}
				// Update the current page
				currentPage = page;
				// Removes hidden class if reviews are found.
				$(reviewsShopifySection).removeClass('hidden');
				$(reviewsCTA).removeClass('hidden');
			} else {
				$(viewMoreReviews).remove();
				$(reviewsCTA).remove();
				console.log('No more reviews to fetch.');
			}
		},
		error: function (jqXHR, textStatus, errorThrown) {
			console.error('Error fetching page:', textStatus, errorThrown);
			$('.embark-location-reviews').remove();
		},
	});
}

// Render the initial set of reviews
function renderInitialReviews() {
	const initialMainReviews = allResults.slice(0, 6);
	const initialModalReviews = allResults.slice(0, 10);

	renderReviews(initialMainReviews, '#reviews');
	renderReviews(initialModalReviews, '#reviews-modal');
	truncateReviewContent();
}

// Render reviews in the specified container
function renderReviews(reviews, containerId) {
	const container = document.querySelector(containerId);
	reviews.forEach((review, index) => {
		const stars = generateStarRating(review.recommendation_likelihood); // Generate star rating HTML for the current review
		const date = formatDate(review.completed_at); // Format review date
		const name = formatReviewerName(review.public_reviewer_name);
		const colClass = containerId === '#reviews' ? 'col-6 col-md-6' : 'col-12'; // Conditionally set column class
		const reviewID = containerId === '#reviews' ? review.id : 'list-' + review.id;
		const reviewHtml = `
			<div id="review-${reviewID}" class="${colClass} review" data-review-id="${review.id}">
				
				<p class="reviewer-name">${name}</p>
				<span class="reviewer-rating">${stars} · <span class="review-date">${date}</span></span>
				<p class="reviewer-content">${review.comments}</p>
			</div>
		`;
		container.innerHTML += reviewHtml; // Append review HTML to container
	});
}

// Splits reviewer name to only show last name initial
function formatReviewerName(fullName) {
  fullName = fullName.trim();
  let formattedName;

  if (fullName.includes(' ')) {
    const nameParts = fullName.split(' ');
    const firstName = nameParts[0];
    const lastNameInitial = nameParts[nameParts.length - 1].charAt(0);
    formattedName = `${firstName} ${lastNameInitial}`;
  } else {
    formattedName = fullName;  // Show the name as is (handles initials or single names)
  }
  return formattedName;
}

// Generate star rating based on a numerical rating (1-10)
function generateStarRating(rating) {
	// Define the maximum number of stars
	const maxStars = 5;
	// Calculate the number of full stars and half stars based on the rating
	const fullStars = Math.floor(rating / 2);
	const hasHalfStar = rating % 2 === 1;
	const halfStars = hasHalfStar ? 1 : 0;
	// Generate the star rating string
	let stars = "";
	for (let i = 0; i < fullStars; i++) {
		stars += "★"; // Full star
	}
	if (hasHalfStar) {
		stars += '<span class="half-star">★</span>'; // Half star
	}
	for (let i = fullStars + halfStars; i < maxStars; i++) {
		stars += "☆"; // Empty star
	}
	return stars;
}

// Format date based on the last four weeks, days ago, or month name
function formatDate(completedAt) {
	const date = new Date(completedAt);
	const currentDate = new Date();
	const daysAgo = Math.floor((currentDate - date) / (1000 * 60 * 60 * 24));
	const weeksAgo = Math.floor(daysAgo / 7);

	if (daysAgo < 1) {
		return 'Today';
	} else if (daysAgo === 1) {
		return 'Yesterday';
	} else if (daysAgo > 1 && daysAgo < 7) {
		// Less than a week ago
		return `${daysAgo} days ago`;
	} else if (weeksAgo === 1) {
		// Exactly 1 week ago
		return '1 week ago';
	} else if (weeksAgo > 1 && weeksAgo <= 4) {
		// Within the last four weeks, show weeks ago
		return `${weeksAgo} weeks ago`;
	} else {
		// Show month name and year
		const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
		return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
	}
}


// Function to truncate review content to a maximum of 150 characters and add "Show More" links
function truncateReviewContent(modalID) {
	// Iterate through each review element
	$('#reviews .review').each(function () {
		// Get the review content within the current review element
		let content = $(this).find('.reviewer-content').text();

		// Get the data-review-id attribute value
		let reviewId = $(this).data('review-id');

		// If the content length exceeds 150 characters
		if (content.length > 150) {
			// Find the index of the last space before the 150th character
			let lastSpaceIndex = content.lastIndexOf(' ', 120);

			// Truncate the content at the last space index
			content = content.slice(0, lastSpaceIndex);

			// Update the review content with the truncated version and append ellipsis
			$(this).find('.reviewer-content').text(content.trim() + '...');

			// Add a "Show More" link after the truncated content with dynamic href
			$(this).append(`<a href="#review-${reviewId}" class="show-more" data-bs-toggle="modal" data-bs-target="#reviewsModal">Show More</a>`);
		}
	});
}

// Fetch the initial reviews on load
$(document).ready(function () {
	fetchPage(1, 30, false, true); // Fetch enough reviews to cover both sections initially
});

// Set up the button to fetch the next page of reviews for the modal
$(viewMoreReviews).on('click', function () {
	fetchPage(currentPage + 1, reviewsPerPage, true);
});